
import ContactFormInputs from "./ContactFormInputs.vue";

export default {
  props: ["subject", "isAgent"],
  components: { ContactFormInputs },
  data() {
    return {
      isVisiable: true,
    };
  },
  methods: {
    show() {
      this.isVisiable = true;
    },
  },
  mounted() {
    this.$vuetify.rtl = true;
  },
};
